import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FlexContainer from '../../../../../common/components/atoms/FlexContainer';
import {
  TrendChartContainer,
  AbsoluteLoading,
  OverlayLoadingMessage
} from './OverlayTraceLegend.styled';

const LegendLoadingState = ({
  optionsVisible,
  chartHeight,
  legendContent
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <FlexContainer>
        <TrendChartContainer
          optionsVisible={optionsVisible}
          chartHeight={chartHeight}
          aria-busy="true"
        >
          <AbsoluteLoading>
            <OverlayLoadingMessage>
              {t('charts.overlay.loadingMeasurements')}
            </OverlayLoadingMessage>
          </AbsoluteLoading>
        </TrendChartContainer>
      </FlexContainer>
      {legendContent}
    </Fragment>
  );
};

LegendLoadingState.propTypes = {
  optionsVisible: PropTypes.bool,
  chartHeight: PropTypes.string,
  legendContent: PropTypes.node.isRequired
};

LegendLoadingState.defaultProps = {
  optionsVisible: false,
  chartHeight: null
};

export default LegendLoadingState;
